import { addEventEntry, addDataLayerEntry } from '@printdeal/data-layer-manager';

enum NavigationEvents {
  ACCOUNT = 'account',
}

export const dispatchDataLayerEventAccountSlideOut = (toggleDropdown: boolean, clickLocation?: 'button' | 'outside_modal') => {
  // GA4
  addDataLayerEntry(NavigationEvents.ACCOUNT, {
    action: `modal_${toggleDropdown ? 'view' : 'close'}`,
    ...(clickLocation && { location: `click_${clickLocation}` }),
  });

  // GA3
  addEventEntry({
    eventCategory: NavigationEvents.ACCOUNT,
    eventAction: `modal_${toggleDropdown ? 'view' : 'close'}`,
    ...(clickLocation && { eventLabel: `click_${clickLocation}` }),
  });
};

export const dispatchDataLayerEventAccountSlideOutLink = (linkText: string) => {
  // GA4
  addDataLayerEntry(NavigationEvents.ACCOUNT, {
    action: 'modal_click',
    link: linkText,
  });

  // GA3
  addEventEntry({
    eventCategory: NavigationEvents.ACCOUNT,
    eventAction: 'modal_click',
    eventLabel: linkText,
  });
};
